module.exports = __webpack_public_path__ + "img/gift.28fe37f2.png";